import { CiLocationOn } from "react-icons/ci";
import { BiPhone } from "react-icons/bi";
import { FiMail } from "react-icons/fi";
import PublicLayout from "../../layouts/PublicLayout";

export default function ContactUs() {
  return (
    <PublicLayout>
      <div className='bg-servicesImage bg-no-repeat bg-cover h-full w-full bg-center'>
        <div className='absolute -z-0 bg-primary opacity-50 w-full h-full'></div>
        <div className='relative z-10 xl:h-screen flex gap-10 xl:flex-row flex-col items-end xl:items-start justify-center w-full p-5'>
          <div dir='rtl' className='flex flex-col xl:mt-[100px] gap-4 xl:w-1/3'>
            <div>
              <h1 className='text-white font-bold text-3xl mb-4'>
                {" "}
                اماكن المركز{" "}
              </h1>
              <hr className='border border-solid border-white' />
            </div>
            <div className=''>
              <div className='flex flex-col gap-4'>
                <p className='text-white font-medium text-2xl'>
                  مركز ظلال الرعاية النهارية
                </p>
                <div className='flex gap-4 flex-row items-center'>
                  <p className='text-white text-2xl'>السعودية</p>
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://www.google.com/maps/place/%D9%85%D8%B1%D9%83%D8%B2+%D8%B8%D9%84%D8%A7%D9%84+%D8%A7%D9%84%D8%B1%D8%B9%D8%A7%D9%8A%D8%A9+%D8%A7%D9%84%D9%86%D9%87%D8%A7%D8%B1%D9%8A%D8%A9%E2%80%AD/@24.7694946,46.6286437,17z/data=!3m1!4b1!4m6!3m5!1s0x3e2ee319eb5de349:0x32a64bcf37c4fd47!8m2!3d24.7694946!4d46.6286437!16s%2Fg%2F11k9s3x71z?hl=en-SA&entry=ttu'
                  >
                    <CiLocationOn
                      size={40}
                      color='#591f8b'
                      className='cursor-pointer p-1 rounded-lg text-black bg-white hover:bg-buttonHover transition-color duration-200'
                    />
                  </a>
                </div>
              </div>
            </div>
            <hr className='border border-solid border-white' />
            <div className=''>
              <div className='flex flex-col gap-4'>
                <p className='text-white text-2xl'>
                  مركز ظل لتنمية المهارات السلوكية والنمائية
                </p>
                <div className='flex gap-4 flex-row items-center'>
                  <p className='text-white text-2xl'>السعودية</p>
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://www.google.com/maps/place/%D9%85%D8%B1%D9%83%D8%B2+%D8%B8%D9%84%D8%A7%D9%84+%D8%A7%D9%84%D8%B1%D8%B9%D8%A7%D9%8A%D8%A9+%D8%A7%D9%84%D9%86%D9%87%D8%A7%D8%B1%D9%8A%D8%A9%E2%80%AD/@24.7694946,46.6286437,17z/data=!3m1!4b1!4m6!3m5!1s0x3e2ee319eb5de349:0x32a64bcf37c4fd47!8m2!3d24.7694946!4d46.6286437!16s%2Fg%2F11k9s3x71z?hl=en-SA&entry=ttu'
                  >
                    <CiLocationOn
                      size={40}
                      color='#591f8b'
                      className='cursor-pointer p-1 rounded-lg text-black bg-white hover:bg-buttonHover transition-color duration-200'
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <p className='border h-full  border-solid border-primary' />
          <div dir='rtl' className='flex flex-col xl:mt-[100px] gap-4 xl:w-1/3'>
            <div>
              <h1 className='text-white font-bold text-3xl mb-4'>
                {" "}
                أرقام التواصل{" "}
              </h1>
              <hr className='border border-solid border-white' />
            </div>

            <div className=''>
              <p className='text-white text-2xl mb-4'>
                مركز ظل للرعاية النهارية
              </p>
              <p className='text-white text-2xl mb-4'>
                الرياض - حي العقيق - شارع الإنتصار
              </p>
              <div className='flex gap-4 flex-row items-center'>
                <p className='text-white text-2xl'>0534636562</p>
                <BiPhone
                  size={40}
                  color='#591f8b'
                  className='cursor-pointer p-1 rounded-lg text-black bg-white hover:bg-buttonHover transition-color duration-200'
                />
              </div>
            </div>

            <div className='border border-solid border-white' />

            <div className=''>
              <p className='text-white text-2xl mb-4'>
                مركز ظل لتنمية المهارات السلوكية والنمائي
              </p>
              <p className='text-white text-2xl mb-4'>
                الرياض - حي الملقا - شارع انس بن للك
              </p>
              <div className='flex gap-4 flex-row items-center'>
                <p className='text-white text-2xl'>0559833211</p>
                <BiPhone
                  size={40}
                  color='#591f8b'
                  className='cursor-pointer p-1 rounded-lg text-black bg-white hover:bg-buttonHover transition-color duration-200'
                />
              </div>
            </div>
          </div>
          <p className='border h-full border-solid border-primary' />
          <div dir='rtl' className='flex flex-col xl:mt-[100px] gap-4 xl:w-1/3'>
            <div>
              <h1 className='text-white font-bold text-3xl mb-4'>
                ايميلات المركز
              </h1>
              <hr className='border border-solid border-white' />
            </div>
            <div className='flex flex-col gap-4'>
              <div className='flex gap-4 flex-row items-center'>
                <p className='text-white text-2xl'>Dhell.center@gmail.com</p>
                <FiMail
                  size={40}
                  color='#591f8b'
                  className='cursor-pointer p-1 rounded-lg text-black bg-white hover:bg-buttonHover transition-color duration-200'
                />
              </div>
              <hr className='border border-solid border-white' />
              <div className='flex gap-4 flex-row items-center'>
                <p className='text-white text-2xl'>Dhell.centro@gmail.com</p>
                <FiMail
                  size={40}
                  color='#591f8b'
                  className='cursor-pointer p-1 rounded-lg text-black bg-white hover:bg-buttonHover transition-color duration-200'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
